import {Grid, Typography, Box, Button, RadioGroup, FormControlLabel, Radio, debounce,} from "@mui/material";
import CampaignCard from "../../card/campaign-card/CampaignCard";
import TextField from "@mui/material/TextField";
import React, { useCallback, useEffect, useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import AudienceService from "../../../../services/api/audience.service";
import {setCampaignAudiences, setTotalSelectedAudience} from "../../../../redux/slices/audience";
import NewActivateConfirmModal from "../../modal/new-activate-confirm-modal/NewActivateConfirmModal";
import StripeService from "../../../../services/api/stripe.service";
import ActivateTopUpCreditModal from "../../modal/activate-top-credit-modal/ActivateTopUpCreditModal";
import {setMessage} from "../../../../redux/slices/message";
import {setMessageSnackbarStateState} from "../../../../redux/slices/common";
import { set } from "react-hook-form";

const CampaignDetails = ({ audienceDetails, connectorCount, connectorData }) => {

    const { user } = useSelector((state) => state.auth.auth);
    const { selectedCountry } = useSelector((state) => state.auth);
    const { currentTheme } = useSelector((state) => state.theme);
    const { campaignAudiences, totalSelectedAudience } = useSelector((state) => state.audience);
    const [ audienceData, setAudienceData] = useState([]);
    const [ amountDetails, setAmountDetails] = useState([]);
    const dispatch = useDispatch();
    const [newActivateConfirmModalState, setNewActivateConfirmModalState] = useState(false);
    const [activateTopUpCreditModalState, setActivateTopUpCreditModalState] = useState(false);

    const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));

    const planMode = user?.planMode || userFromLocalStorage?.planMode;

   useEffect(() => {
    let mounted = true;

    if (mounted && user && selectedCountry) {
        const queryParams = [
            `userId=${user.id}`,
            `countryId=${selectedCountry.id}`,
        ];

        if (audienceDetails?.audienceId || audienceDetails?.id) {
            queryParams.push(`audienceId=${audienceDetails.audienceId || audienceDetails.id}`);

            const isAddAudiencesCount = campaignAudiences
                .filter(audience => audience.isAdd)
                .reduce((acc, audience) => acc + audience.totalAudienceCount, 0);

            const totalAudienceCount =
                isAddAudiencesCount + audienceDetails.audience || audienceDetails.totalAudienceCount;

            dispatch(setTotalSelectedAudience(totalAudienceCount));
        }


        // 🔹 API 1: Get Campaign Audience
        AudienceService.getCampaignAudience(queryParams.join('&'))
            .then((audienceData) => {
                const audienceList = (audienceData.results || []).filter(
                    item => item.isUploaded === true
                );

                // 🔹 API 2: Additional API call
                return AudienceService.getSegments(
                    `userId=${user.id}&countryId=${selectedCountry.id}`
                ).then((segmentData) => {
                    const segmentList = (segmentData?.results || []).filter(
                        item => item.isUploaded === true
                    );

                    // 🔹 Merge both responses
                    const combinedAudienceList = [
                        ...audienceList,
                        ...segmentList
                    ];

                    if (combinedAudienceList.length > 0) {
                        setAudienceData(combinedAudienceList);
                    } else {
                        setAudienceData([]);
                    }
                });
            })
            .catch((error) => {
                console.log(error);
            });

        const queryCalcParams = [
            `userId=${user.id}`,
            `countryId=${selectedCountry.id}`,
        ];

        if (audienceDetails?.audienceId || audienceDetails?.id) {
            queryCalcParams.push(`audienceCount=${totalSelectedAudience}`);
        }

        queryCalcParams.push(`connectorsCount=${1}`);

        StripeService.getAmount(queryCalcParams.join('&'))
            .then((data) => {
                if (data?.results) {
                    setAmountDetails(data.results);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return () => {
        mounted = false;
    };
}, [user, selectedCountry]);


    const handleSearchChange = (event) => {

        const searchText = event.target.value.toLowerCase();

        if (audienceData?.length && searchText.length > 1) {

            const filteredAudList = audienceData.filter((aud) =>
                aud.name.toLowerCase().startsWith(searchText)
            );

            // Merge and filter out duplicates based on id
            const updatedAudiences = [...campaignAudiences, ...filteredAudList]
                .reduce((acc, cur) => {
                    if (!acc.some(item => item.id === cur.id)) {
                        acc.push(cur);
                    }
                    return acc;
                }, []);

            const searchedData = updatedAudiences.filter((aud) =>
                aud.name.toLowerCase().startsWith(searchText)
            );

// Add objects with isAdd true from campaignAudiences
            const alwaysIncluded = campaignAudiences.filter((aud) => aud.isAdd);

// Combine both results, ensuring no duplicates
            const combinedData = [...searchedData, ...alwaysIncluded.filter(aud =>
                !searchedData.some(item => item.id === aud.id)
            )];


            dispatch(setCampaignAudiences(combinedData));

        } else {

            const filteredAudList = campaignAudiences.filter((aud) => aud.isAdd);
            dispatch(setCampaignAudiences(filteredAudList));
        }
    }

    const handleAudienceConfirmClick = () => {

        if (!totalSelectedAudience > 0) {

            dispatch(setMessage({
                type: "error",
                title: "Please Select a card to activate audiences",
            }));
            dispatch(setMessageSnackbarStateState(true));
            return;
        }

        if (planMode === 'Trial') {

            setActivateTopUpCreditModalState(true);

        } else if (planMode === 'credit' && totalCost > amountDetails.totalCreditAvailable) {

            setActivateTopUpCreditModalState(true);
        } else {


            if(connectorCount === 0) {
                dispatch(setMessage({
                    type: "error",
                    title: "Please select a connector",
                }));
                dispatch(setMessageSnackbarStateState(true));
                return;
            }
            setNewActivateConfirmModalState(true);
        }
    }

    const calculateCost = (totalAudience, costPerThousand) => {
        // Calculate total cost
        return ((totalAudience * costPerThousand) / 1000).toFixed(2);
    };

    // const audienceMultiplier = connectorCount === 0 ? 1 : connectorCount;
    // const totalAudience = totalSelectedAudience * audienceMultiplier;
//    const totalCost = calculateCost(totalAudience, amountDetails.costPerAudience);
    const selectedCardCount = campaignAudiences.filter(audience => audience.isAdd === true).length;

    const totalCost =
        (selectedCardCount || 1) *
        (connectorCount ?? 1) *
        (amountDetails?.platformCost ?? 200);

  const [searchTerm, setSearchTerm] = useState('');

const fetchAudiences = useCallback((term, type) => {
  const queryParams = [
    `userId=${user.id}`,
    `countryId=${selectedCountry.id}`,
  ];

  // include search if present
  if (term.length >= 3) {
    queryParams.push(`search=${encodeURIComponent(term)}`);
  }

  // existing audience details
  if (audienceDetails?.audienceId || audienceDetails?.id) {
    queryParams.push(`audienceId=${audienceDetails.audienceId || audienceDetails.id}`);

    const isAddAudiencesCount = campaignAudiences
      .filter(a => a.isAdd)
      .reduce((acc, a) => acc + a.totalAudienceCount, 0);

    const totalAudienceCount =
      isAddAudiencesCount + audienceDetails.audience || audienceDetails.totalAudienceCount;

    dispatch(setTotalSelectedAudience(totalAudienceCount));
  }

  // 🔹 Existing API call
  AudienceService.getCampaignAudience(queryParams.join('&'))
    .then(audienceData => {
      const audienceList = (audienceData.results || []).filter(
  item => item.isUploaded === true
);

      // 🔹 NEW: segment API call
      return AudienceService.getSegments(
        `userId=${user.id}&countryId=${selectedCountry.id}`
      ).then(segmentData => {
        const segmentList = (segmentData?.results || []).filter(
  item => item.isUploaded === true
);

        // 🔹 Merge both lists
        const combinedList = [
          ...audienceList,
          ...segmentList
        ];

        setAudienceData(combinedList.length ? combinedList : []);
      });
    })
    .catch(console.error);

}, [user.id, selectedCountry.id, audienceDetails, campaignAudiences, dispatch]);


  // Debounced version
  const debouncedFetch = useCallback(
    debounce((term, type) => {
      fetchAudiences(term, type);
    }, 300),
    [fetchAudiences]
  );

  // Trigger on search or type change
  useEffect(() => {
    if (searchTerm.length >= 3) {
      debouncedFetch(searchTerm);
    } else if (searchTerm.length === 0) {
      // clear or initial fetch
      fetchAudiences('');
    }
  }, [searchTerm, debouncedFetch, fetchAudiences]);

//   const handleTypeChange = e => {setSelection(e.target.value);setSearchTerm('');};
//   const handleSearchChange = e => setSearchTerm(e.target.value);

    return (<>
        <Box
            style={{
                paddingTop: '15px',
                paddingLeft: "15px",
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: '100vh'
            }}
        >
            {audienceDetails && (audienceDetails.audienceId || audienceDetails?.id) && (
                <Box style={{paddingTop: '15px', paddingRight: '5px', paddingLeft: '15px'}}>
                    <Typography style={{ fontFamily: "Manrope, Arial, sans-serif", marginTop: "2px", fontSize: "22px", fontWeight: 700, lineHeight: "43.71px", textAlign: "left" }} gutterBottom>
                        Campaign Details
                    </Typography>
                    <Grid>
                        <Grid sx={{ paddingTop: "5px" }}>
                            <CampaignCard isClose={true} audienceDetails={audienceDetails}/>
                        </Grid>
                    </Grid>
                </Box>
            )}

            <Box style={{ paddingLeft: "15px", paddingTop: audienceDetails && (audienceDetails.audienceId || audienceDetails?.id) ? '0px' : '15px' }}>
                {/* <Typography
                style={{
                fontFamily: "Manrope, Arial, sans-serif",
                fontSize: "20px",
                fontWeight: 700,
                lineHeight: "43.71px",
                textAlign: "left",
                marginBottom: "16px",
                }}
                gutterBottom
            >
                Select Type
            </Typography> */}

             <Typography
                style={{
                fontFamily: "Manrope, Arial, sans-serif",
                fontSize: "20px",
                fontWeight: 700,
                lineHeight: "43.71px",
                textAlign: "left",
                marginBottom: "16px",
                }}
                gutterBottom
            >
                Select Audience
            </Typography>

            {/* <RadioGroup
                row
                value={selection}
                onChange={handleTypeChange}
                aria-label="select-type"
                name="select-type"
            >
                <FormControlLabel
                value="0"
                control={<Radio />}
                label="Audience"
                sx={{
                    "& .MuiTypography-root": {
                    fontFamily: "Manrope, Arial, sans-serif",
                    fontWeight: 700,
                    fontSize: "14px",
                    color: currentTheme === 'dark' ? '#ffffff' : undefined
                    },
                }}
                />
                <FormControlLabel
                value="1"
                control={<Radio />}
                label="Segment"
                sx={{
                    "& .MuiTypography-root": {
                    fontFamily: "Manrope, Arial, sans-serif",
                    fontWeight: 700,
                    fontSize: "14px",
                     color: currentTheme === 'dark' ? '#ffffff' : undefined  
                    },
                }}
                />
            </RadioGroup> */}
                <TextField variant="standard" placeholder='Type to search' inputProps={{ style: { color: currentTheme === 'dark' ? '#ffffff' : undefined   } }} style={{ width: "300px", height: "45px" }} onChange={handleSearchChange} />
                <Box className="SliderBox"
                     style={{ height: audienceDetails && (audienceDetails.audienceId || audienceDetails?.id) ? "310px" :"490px", width: "100%",
                         overflowY: "auto", overflowX: "hidden",
                         paddingTop: '5px',
                         borderRadius: '20px',
                     }}>
                    <Grid container>
                        {campaignAudiences && campaignAudiences.map((data, index) => (
                            <Grid item key={index} xs={12} sx={{ paddingTop: "10px" }}>
                                <CampaignCard audienceDetails={data}/>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>

            <Box className="last" style={{ paddingBottom: '25px',display: "flex", alignItems: "center", flexDirection: "column" , gap: 5}} >
                <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} style={{ width: "95%"}}>
                    <Box>
                        <Typography style={{ fontFamily: "Manrope, Arial, sans-serif", fontSize: "14px", fontWeight: 200,  color: currentTheme === 'dark' ? '#ffffff' : undefined }} gutterBottom>
                            Available Credits
                        </Typography>
                        <Typography style={{ fontFamily: "Manrope, Arial, sans-serif", marginTop: "1px", fontSize: "14px", fontWeight: 200,  color: currentTheme === 'dark' ? '#ffffff' : undefined  }} gutterBottom>
                            Selected Audience by Credits
                        </Typography>
                    </Box>
                    <Box>
                     <Typography style={{ fontFamily: "Manrope, Arial, sans-serif",  fontSize: "14px", fontWeight: 700, color: '#39BF8F'}} gutterBottom>
                         { amountDetails.totalCreditAvailable !== undefined || null ? `$ ${amountDetails?.totalCreditAvailable?.toLocaleString()}` : '$0'}
                     </Typography>
                        <Typography style={{ fontFamily: "Manrope, Arial, sans-serif", fontSize: "14px", fontWeight: 700,  color: totalCost > (amountDetails.totalCreditAvailable || 0) ? '#C02026' : '#39BF8F'}} gutterBottom
                        >
                            {`$ ${totalCost}`}
                        </Typography>
                    </Box>
                </Box>
                    <Button
                        variant='contained'
                        fullWidth
                        type='submit'
                        className="form-button"
                        sx={{ textTransform: "none", borderRadius: "8px", width: '95%' }}
                        onClick={handleAudienceConfirmClick}
                    >
                        SUBMIT
                    </Button>
            </Box>
        </Box>




            <NewActivateConfirmModal
                audience={audienceDetails}
                newActivateConfirmModalState={newActivateConfirmModalState}
                setNewActivateConfirmModalState={setNewActivateConfirmModalState}
                connectorData={connectorData}
                connectorCount={connectorCount}
            />


        {activateTopUpCreditModalState &&
            <ActivateTopUpCreditModal
                activateTopUpCreditModalState={activateTopUpCreditModalState}
                setActivateTopUpCreditModalState={setActivateTopUpCreditModalState}
            />
        }

    </>);
}


export default CampaignDetails;